import { X } from "lucide-react"
import { Dialog, DialogContent } from "@/components/molecules/Dialog/content"
import { DialogHeader } from "@/components/molecules/Dialog/header"
import { Button } from "@/components/atoms/Button/button"
import { SearchPropertyForm } from "./index"
import { useModalStore } from "@/hooks/useModal"
import { ClientProviders } from "@/app/providers"

export function PropertySearchModal() {
  const { modals, closeModal } = useModalStore()

  return (
    <ClientProviders>
      <Dialog
        open={!!modals["property"]}
        onOpenChange={() => closeModal("property")}
      >
        <DialogContent
          className="w-full max-w-md sm:max-w-xl md:max-w-2xl mx-auto rounded-2xl bg-white p-4 sm:p-6 dark:bg-gray-900"
        >
          <DialogHeader>
            <div className="flex justify-end">
              <Button
                variant="ghost"
                className="p-2"
                onClick={() => closeModal("property")}
              >
                <X className="text-gray-500 dark:text-gray-400" size={24} />
              </Button>
            </div>
          </DialogHeader>

          <div className="mt-4">
            <SearchPropertyForm />
          </div>
        </DialogContent>
      </Dialog>
    </ClientProviders>
  )
}
